import { render, staticRenderFns } from "./drawerAddAccess.vue?vue&type=template&id=5b075b7c&"
import script from "./drawerAddAccess.vue?vue&type=script&lang=js&"
export * from "./drawerAddAccess.vue?vue&type=script&lang=js&"
import style0 from "./drawerAddAccess.vue?vue&type=style&index=0&id=5b075b7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports